import React, { HTMLAttributes } from 'react'

import { StyledBanner } from './index.styled'
type BannerProps = {
  children?: React.ReactNode
  color?: string
} & HTMLAttributes<HTMLDivElement>

export const Banner = ({ children, style, ...rest }: BannerProps) => {
  return (
    <StyledBanner
      style={{
        backgroundColor: rest.color || undefined,
        ...style,
      }}
      {...rest}
    >
      {children}
    </StyledBanner>
  )
}
